import ApplicationStore from '../stores/ApplicationStore';
import QuickstartStore from '../stores/QuickstartStore';
import loadDocument from './loadDocument';
import getQuickstartMetadata from '../util/getQuickstartMetadata';
import resolveQuickstart from '../util/resolveQuickstart';

const TutorialNavigatorActions = {};

TutorialNavigatorActions.home = (context) => {
  const selected = {};
  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

TutorialNavigatorActions.quickstartList = (context) => {
  const selected = {};

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

TutorialNavigatorActions.quickstart = (context, payload) => {
  const { params } = payload;
  const quickstarts = context.getStore(QuickstartStore).getQuickstarts();
  const selected = resolveQuickstart(quickstarts, params);

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', selected);
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    })
  ]);
};

TutorialNavigatorActions.platform = (context, payload) => {
  const { params } = payload;
  const quickstarts = context.getStore(QuickstartStore).getQuickstarts();
  const isFramedMode = context.getStore(ApplicationStore).isFramedMode();
  const selected = resolveQuickstart(quickstarts, params, isFramedMode);

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', { ...selected, isFramedMode });
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    }),
    context.executeAction(loadDocument, { url: selected.url })
  ]);
};

TutorialNavigatorActions.article = (context, payload) => {
  const { params } = payload;
  const quickstarts = context.getStore(QuickstartStore).getQuickstarts();
  const isFramedMode = context.getStore(ApplicationStore).isFramedMode();
  const selected = resolveQuickstart(quickstarts, params, isFramedMode);

  return Promise.all([
    getQuickstartMetadata(selected).then((metadata) => {
      context.dispatch('QUICKSTART_SELECTED', { ...selected, isFramedMode });
      context.dispatch('UPDATE_PAGE_METADATA', metadata);
    }),
    context.executeAction(loadDocument, { url: selected.url })
  ]);
};

export default TutorialNavigatorActions;
